import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApiConnectionDetailComponent } from './json-users-todo-detail/api-connection-detail.component';
import { ApiConnectionComponent } from './json-users/api-connection.component';
import { ContactComponent } from './contact/contact.component';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { TodosComponent } from './json-todos/todos.component';
import { GithubReposComponent } from './github-repos/github-repos.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent},
  { path: 'jsonApi', component: ApiConnectionComponent,
    children:[
      { path: 'detail/:id', component: ApiConnectionDetailComponent},
    ]},
  { path: 'todos', component: TodosComponent},
  { path: 'github', component: GithubReposComponent},
  { path: 'contact', component: ContactComponent},
  { path: '', redirectTo: '/home', pathMatch: 'full'},
  { path: '**', component: ErrorComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
